import styled from "styled-components";

export const Content = styled.div`
  display: grid;
  grid-auto-flow: column;
  align-items: center;
  gap: 2em;
  max-width: calc(100% - 2 * 134px);
  margin-left: 1.7em;
`;
export const Image = styled.img`
  max-width: 434px;
  width: 100%;
  margin: 0 6em 0 0;
  user-select: none;
`;
export const MainContent = styled.div`
  max-width: 400px;
`;
export const Title = styled.h1`
  font-weight: normal;
  font-size: 2rem;
  margin-top: 0;

  span {
    display: block;
    font-size: 3.375rem;
  }
`;
export const Description = styled.p`
  font-size: 0.875rem;
  color: #888888;
  line-height: 200%;
  margin-bottom: 2em;
`;

export const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const DecorationLeft = styled.div`
  background: url("img/assessments-decoration.svg");
  background-repeat: no-repeat;
  width: 127px;
  height: 674px;
`;
